import type { ReactNode } from 'react'
import type { HavenLaunchAction } from '@/features/adviser-chat/lib/types'
import { WelcomeHero } from '@/features/adviser-chat/components/WelcomeHero'
import { SuggestionList } from '@/features/adviser-chat/components/SuggestionList'
import '../adviser-chat.scss'

interface WelcomeScreenProps {
  firstName?: string
  input?: ReactNode
  illustrationClassName?: string
  onSuggestionClick: (message: string) => void
  onLaunchAction?: (action: HavenLaunchAction) => void
}

export const WelcomeScreen = ({
  firstName,
  input,
  illustrationClassName,
  onSuggestionClick,
  onLaunchAction,
}: WelcomeScreenProps) => {
  return (
    <div className="flex flex-col flex-1 min-h-0 w-full max-w-[688px] mx-auto justify-center overflow-hidden px-6 py-6 text-center">
      <div className="flex flex-col items-center gap-8 shrink-0">
        <WelcomeHero
          firstName={firstName}
          illustrationClassName={illustrationClassName}
        />
        {input && <div className="w-full">{input}</div>}
      </div>
      {/* Prompts take what room is left and clip whole rows, never the input. */}
      <div className="flex min-h-0 w-full flex-col overflow-hidden pt-6">
        <SuggestionList
          onSuggestionClick={onSuggestionClick}
          onLaunchAction={onLaunchAction}
        />
      </div>
    </div>
  )
}
